export default __webpack_public_path__ + "static/media/arrow_dashboard.c7fd3648.svg";